import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

// //Import Scrollbar
import SimpleBar from 'simplebar-react';

// MetisMenu
import MetisMenu from 'metismenujs';
import { Link, useLocation } from 'react-router-dom';
import withRouter from '../Common/withRouter';

//i18n
import { withTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { ROLES } from '../../constants/layout';
import { useAuthStore } from '../../zustand-store/auth.store';
import PricingModal from '../../components/Common/upgrade-pricing-modal';
import CalendarIcon from '../../assets/svg/calendar';
import ClientIcon from '../../assets/svg/client';
import ServiceIcon from '../../assets/svg/services';
import PaymentIcon from '../../assets/svg/payment';
import AnalaticsIcon from '../../assets/svg/analatics';
import SettingIcon from '../../assets/svg/setting';
const SidebarContent = (props) => {
  const ref = useRef();
  const path = useLocation();
  const [isDropDownActive, setIsDropDownActive] = useState(false);

  const settingCollapse = [
    'business-settings',
    'appointment-settings',
    'integration-settings',
    'Notifications',
    'paymentlogs',
    'business',
    'refunds',
    'users',
    'businessAccess',
    'adminlocationbillingdetails'
  ];
  const { role, currentPlan } = useAuthStore((state) => state);
  const [showPricingModal, setShowPricingModal] = useState(false);
  const [isPlatformDropDownActive, setIsPlatformDropDownActive] = useState(false);

  const activateParentDropdown = useCallback((item) => {
    item.classList.add('active');
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== 'side-menu') {
      parent2El.classList.add('mm-show');
    }

    if (parent) {
      parent.classList.add('mm-active');
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add('mm-show'); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add('mm-active'); // li
          parent3.childNodes[0].classList.add('mm-active'); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add('mm-show'); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add('mm-show'); // li
              parent5.childNodes[0].classList.add('mm-active'); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  useEffect(() => {
    if (settingCollapse.includes(path.pathname.split('/')[1])) {
      setIsDropDownActive(true);
    }
  }, [settingCollapse]);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains('active')) {
        item.classList.remove('active');
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.remove('mm-show');
        }

        parent.classList.remove('mm-active');
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove('mm-show');

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('mm-active'); // li
            parent3.childNodes[0].classList.remove('mm-active');

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove('mm-show'); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('mm-show'); // li
                parent5.childNodes[0].classList.remove('mm-active'); // a tag
              }
            }
          }
        }
      }
    }
  };

  const getBasePath = () => {
    const segments = path.pathname.split('/').filter(Boolean); // Split and filter out empty segments
    return segments.length > 0 ? `/${segments[0]}` : ''; // Return the first segment
  };
  const activeMenu = useCallback(() => {
    // console.log(getBasePath())
    const pathName = getBasePath();

    let matchingMenuItem = null;
    const ul = document.getElementById('side-menu');
    const items = ul.getElementsByTagName('a');
    removeActivation(items);
    for (let i = 0; i < items.length; ++i) {
      const itemPath = items[i].pathname;

      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
      // Make Appointments active for both /calender and /adminAppointment
      if (
        (itemPath === '/calender' &&
          (pathName === '/calender' || pathName === '/adminAppointment')) ||
        pathName === itemPath
      ) {
        matchingMenuItem = items[i];
        break;
      }
    }
    // Force "Reports" to stay active on specific pages
    if (
      path.pathname.includes('/reports') ||
      path.pathname.includes('/todayBookingsReport') ||
      path.pathname.includes('smsemailreport')
    ) {
      const reportsMenuItem = document.querySelector('a[href="/reports"]');
      if (reportsMenuItem) {
        activateParentDropdown(reportsMenuItem);
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu('#side-menu');
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link to="/calender" className="d-flex align-items-center">
                <CalendarIcon className="menu-icon" />
                {/* <i className="bx bx-calendar"></i> */}
                <span>{props.t('Appointments')}</span>
              </Link>
            </li>
            <li>
              <Link to="/customers" className="d-flex align-items-center">
                <ClientIcon className="menu-icon" />
                {/* <i className="bx bx-group"></i> */}

                <span>{props.t('Customers')}</span>
              </Link>
            </li>
            <li id="service">
              <Link to="/services" className="d-flex align-items-center">
                {/* <i className="mdi mdi-dots-square"></i> */}
                <ServiceIcon className="menu-icon" />
                <span>{props.t('Services')}</span>
              </Link>
            </li>
            <li>
              <Link to="/payments" className="d-flex align-items-center">
                {/* <i className="mdi mdi-credit-card-outline"></i> */}
                <PaymentIcon className="menu-icon" />
                <span>{props.t('Payments')}</span>
              </Link>
            </li>

            {(role === ROLES.SUPER_ADMIN ||
              role === ROLES.BUSINESS_ADMIN ||
              role === ROLES.PLATFORM_ADMIN) && (
              <li>
                <Link to="/dashboardlist" className="d-flex align-items-center">
                  {/* <i className="mdi mdi-chart-bar"></i> */}
                  <AnalaticsIcon className="menu-icon" />
                  <span>{props.t('Insights')}</span>
                </Link>
              </li>
            )}
            {/* <li>
              <Link to="/dashboard-business-admin" className=" ">
                <i className="bx bx-grid-alt"></i>

                <span>{props.t('Dashboard Business admin')}</span>
              </Link>
            </li> */}
            {/* <li>
              <Link to="/dashboard-platform-admin" className=" ">
                <i className="bx bx-grid-alt"></i>

                <span>{props.t('Dashboard Platform admin')}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/adminAppointment" className=" ">
                <i className="bx bx-task"></i>
                <span>{props.t('Appointments')}</span>
              </Link>
            </li> */}

            {/* {role == ROLES.SUPER_ADMIN && (
              <li>
                <Link to="/todayBookingsReport" className=" ">
                  <i className="bx bx-task"></i>
                  <span>{props.t('Booking Report')}</span>
                </Link>
              </li>
            )} */}
            {(role === ROLES.SUPER_ADMIN || role === ROLES.PLATFORM_ADMIN) && (
              <li>
                <Link to="/reports" className="d-flex align-items-center">
                  {/* <i className="bx bx-task"></i> */}
                  {/* <i className="mdi mdi-chart-bar"></i> */}
                  <AnalaticsIcon className="menu-icon" />
                  <span>{props.t('Reports')}</span>
                </Link>
              </li>
            )}

            {/* {role == ROLES.SUPER_ADMIN  && (
              <li>
                <Link to="/apilogs" className=" ">
                <i className="bx bx-list-ul"></i>


                  <span>{props.t('Api Logs')}</span>
                </Link>
              </li>
            )} */}
            {/* {role == ROLES.SUPER_ADMIN  && (
              <li>
                <Link to="/appfees" className=" ">
                  <i className="bx bx-dollar"></i>
                  <span>{props.t('App Fee')}</span>
                </Link>
              </li>
            )} */}

            <li>
              <Link
                onClick={() => setIsDropDownActive(!isDropDownActive)}
                to="/#"
                //className="has-arrow"
                className="setting-style has-arrow"
              >
                <i className="bx bx-cog setting-icon" style={{ fontWeight: '400' }}></i>
                <span style={{ fontWeight: '400' }}>{props.t('Settings')}</span>
              </Link>
              <ul
                className={`sub-menu mm-collapse ${isDropDownActive ? 'mm-show' : ''}`}
                aria-expanded="false"
              >
                {(role == ROLES.SUPER_ADMIN ||
                  role == ROLES.BUSINESS_ADMIN ||
                  role == ROLES.PLATFORM_ADMIN) && (
                  <li>
                    <Link to="/users" className=" ">
                      {/* <i className="bx bx-group"></i> */}
                      <span>{props.t('Users')}</span>
                    </Link>
                  </li>
                )}
                {role == ROLES.BUSINESS_ADMIN && (
                  <li>
                    <Link to="/businessAccess" className=" ">
                      <span>{props.t('Billing')}</span>
                    </Link>
                  </li>
                )}

                {(role == ROLES.SUPER_ADMIN || role == ROLES.PLATFORM_ADMIN) && (
                  <li>
                    <Link to="/adminlocationbillingdetails" className=" ">
                      <span>{props.t('Billing Details')}</span>
                    </Link>
                  </li>
                )}
                {(role == ROLES.SUPER_ADMIN ||
                  role == ROLES.BUSINESS_ADMIN ||
                  role == ROLES.PLATFORM_ADMIN) && (
                  <li>
                    <Link to="/business" className=" ">
                      {/* <i className="bx bx-briefcase"></i> */}
                      <span>{props.t('Business')} Info</span>
                    </Link>
                  </li>
                )}
                <li>
                  <Link to="/business-settings">{props.t('Availability')}</Link>
                </li>
                <li>
                  <Link to="/appointment-settings">{props.t('Appointment')}</Link>
                </li>
                <li>
                  <Link to="/integration-settings">{props.t('Integration')}</Link>
                </li>
                {(role == ROLES.SUPER_ADMIN ||
                  role == ROLES.BUSINESS_ADMIN ||
                  role == ROLES.PLATFORM_ADMIN) && (
                  <li>
                    <Link to="/Notifications">{props.t('Notifications')}</Link>
                  </li>
                )}
                <li>
                  <Link to="/paymentlogs" className=" ">
                    {/* <i className="bx bx-file"></i> */}

                    <span>{props.t('Payment Logs')}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/refunds" className=" ">
                    {/* <i className="bx bx-undo"></i> */}

                    <span>{props.t('Refunds')}</span>
                  </Link>
                </li>
              </ul>
            </li>
            {(role === ROLES.SUPER_ADMIN || role === ROLES.PLATFORM_ADMIN) && (
              <li>
                <Link
                  onClick={() => setIsPlatformDropDownActive(!isPlatformDropDownActive)}
                  to="/#"
                  className="has-arrow setting-style"
                >
                  <i className="bx bx-cog setting-icon" style={{ fontWeight: '400' }}></i>
                  <span style={{ fontWeight: '400' }}>{props.t('Platform Settings')}</span>
                </Link>

                <ul
                  className={`sub-menu ${isPlatformDropDownActive ? 'mm-show' : 'mm-collapsing'}`}
                  aria-expanded="false"
                >
                  <li>
                    <Link to="/platformusers">
                      <span>{props.t('Platform Users')}</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/apilogs">
                      <span>{props.t('API Logs')}</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/appfees">
                      <span>{props.t('App Fee')}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/allbusiness">
                      <span>{props.t('All Business')}</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/businessAccess" className=" ">
                      <span>{props.t('Subscription Plans')}</span>
                    </Link>
                  </li>
                </ul>
              </li>
            )}
          </ul>
        </div>
      </SimpleBar>
      {!isDropDownActive && (
        <div>
          {/* Fixed bottom upgrade box */}
          {currentPlan === 'Starter' && (
            <div className="p-3" style={{ position: 'absolute', bottom: 0, zIndex: 9999 }}>
              <div className="border rounded p-3 bg-white shadow-sm text-center">
                <div className="fw-bold mb-2 text-dark">
                  Upgrade to <span className="badge bg-dark">Pro</span>
                </div>
                <p className="text-muted small">
                  Upgrade to Pro and access all the features to help grow your business.
                </p>

                <div
                  onClick={() => {
                    setShowPricingModal(true);
                    //   setIsDropDownActive(true)
                  }}
                  className="btn btn-dark w-100 d-flex align-items-center justify-content-center gap-2"
                  style={{ cursor: 'pointer' }}
                >
                  Upgrade <i className="bx bx-crown"></i>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <PricingModal isOpen={showPricingModal} onClose={() => setShowPricingModal(false)} />
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any
};

export default withRouter(withTranslation()(SidebarContent));
